import { FlashMessageDto } from "src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto";
import { UIComponentViewImpl } from "../../../../toolkit/uicomponentview";
import { MsisdnFloatingTextComponent } from "../../../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent";
import { LoaderWrapperComponent } from "../../loaderwrappercomponent";
import { SetFlashMessageComponentHandler, SetFlashMessageComponentProps, SetFlashMessageComponentState } from "./setflashmessagecomponent";
import { SetFlashMessageCSSStyle } from "./setflashmessagecss";
import * as React from "react";
import { MSISDNValidation } from "../../../../toolkit/msisdnvalidation/msisdnvalidation";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { ButtonComponent } from "../../../../toolkit/button/buttoncomponent";
import { ConfirmRequestConfirmButtonCSSStyleImpl } from "../../confirmrequest/confirmrequestconfirmbuttoncss";
import { LoaderComponent } from "../../../../toolkit/loader/loadercomponent";
import { SubscriberValidationDtoImpl } from "src/com/sixdee/crbtportal/core/dto/subscribervalidation/subscribervalidationdto";
import { ToggleButtonCSSStyleImpl } from "../../../../toolkit/togglebutton/togglebuttoncss";
import { SpecialCallerTextComponent } from "../../../../toolkit/text/msisdntext/specialcallertextcomponent";
import { FlashMessageToggleButtonGroupComponent } from "../../../../toolkit/togglebuttongroup/flashmesasgetogglebuttongroupcomponent";

export class SetFlashMessageViewImpl extends UIComponentViewImpl<FlashMessageDto>
{

    private contactNumber:MsisdnFloatingTextComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;
    private specialCallerRef: any;

    bindHandlers()
    {   
        this.onClosePopup = this.onClosePopup.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.onTabSelected = this.onTabSelected.bind(this);
    }

    draw(props: SetFlashMessageComponentProps, state: SetFlashMessageComponentState, cssStyle: SetFlashMessageCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                {
                    this.getWebView(props, state, cssStyle)
                }

                  <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>

            </div>
        );
    }


    getWebView(props: SetFlashMessageComponentProps, state: SetFlashMessageComponentState, cssStyle: SetFlashMessageCSSStyle):JSX.Element
    {
      
        let tabsTitlesList = props.context.getUserContext().getIsLoggedIn() ? 
        [props.context.getResources().getString(Strings.all_callers), props.context.getResources().getString(Strings.special_caller)]
        : [props.context.getResources().getString(Strings.all_callers)];
        return(
            <>
                    <div style={cssStyle.getHeaderDivCSSStyle()}>
                        <label style={cssStyle.getTitleCSSStyle()}>{props.context.getResources().getString(Strings.flash_message)}</label>
                        <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onClosePopup}>
                        <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                    </div>
                    </div>
                    <FlashMessageToggleButtonGroupComponent onTabSelected={this.onTabSelected} initialSelection={props.context.getResources().getString(Strings.all_callers)} style={new ToggleButtonCSSStyleImpl(props.context)} context={props.context} listOfTitles={tabsTitlesList} />
                    <div id="set-flash-msg-main">
                            <div id="set-flash-msg-header-main">
                                    <div style={{width:"85%",background:"#000000 0% 0% no-repeat padding-box", height:"270px",border:"1px solid #F4F4F4",borderRadius: "6px 6px 0px 0px",margin:"30px",backgroundColor:"#F4F4F4"}}>
                                       <div style={{width:"68px", height:"205px", marginTop:"25px",color:"#FFC400"}}>
                                                <img  width="68px" height="205px" src={this.getContext().getResources().getImage("quotes.svg")}/>
                                       </div>
                                       <div style={{width:"auto",height:"53px",fontSize:"21px",lineHeight:"21px",textAlign:"center",top:"-102.5px",position:"relative",color:"#000000"}}>
                                            {props.flashMessageDto.getStatusMessage()}
                                       </div>
                                    </div>
                             </div> 
                                   
                   </div>
                   {
                    !props.context.getUserContext().getIsLoggedIn() &&
                      <div> 
                                <div style={cssStyle.getMobileNumberCSSStyle()}>
                                <MsisdnFloatingTextComponent hint={props.context.getResources().getString(Strings.mobilenumberhint)} maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => this.contactNumber = item} id={"#mobilenumber"} value={""} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.entercontactnumber)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)}/>
                                </div> 
                      </div>    
                   }
                   {
                    props.context.getUserContext().getIsLoggedIn() && !state.isAllCallersSelected &&
                   <div style={{width:"100%", paddingLeft: "30px"}}>
                        <div style={{width: "304px", paddingLeft: "0px", paddingRight: "30px", paddingTop: "20px"}}>
                        <SpecialCallerTextComponent hint={this.getContext().getResources().getString(Strings.mobilenumberhint)} maxLength={this.getContext().getResources().getString(Strings.numberMaxLength)} label={this.getContext().getResources().getString(Strings.entercontactnumber)} ref={(item: any)=>{this.specialCallerRef = item;}} placeholder={this.getContext().getResources().getString(Strings.add_number)}  isDisabled={false} id={"#mobilenumber"} value={""} inputType={"number"} isRequired={false}  context={this.getUIProps().context} emptyErrorMsg={this.getUIProps().context.getResources().getString(Strings.numberIncorrect)}/> 
                        </div>
                   </div>
                    }
                
                    <div style={cssStyle.getConfirmButtonCSSStyle()}>
                          <ButtonComponent onClick={this.onNextClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.next)}/>
                    </div>
                    

            </>
        );
    }

    onTabSelected(title: string)
    {
        (this.getUIComponentHandler() as SetFlashMessageComponentHandler).onTabSelected(
            title === this.getContext().getResources().getString(Strings.all_callers) ? true : false);
    }

    showLoader()
    {       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    onNextClick()
    {
        (this.getUIComponentHandler() as SetFlashMessageComponentHandler).onNextClick();
    }

    onClosePopup():void
    {
        (this.getUIProps() as SetFlashMessageComponentProps).closePopup();
    }

    validateSpecialCaller()
    {
        if(this.specialCallerRef?.validate())
        {
            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.specialCallerRef.getData());
            
            let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
            let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);
            if(!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength))
            {
                this.specialCallerRef.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                return false;
            }
            else if(this.getContext().getUserContext().getMsisdn() === this.specialCallerRef.getData())
            {
                this.specialCallerRef.setErrorMessage(this.getContext().getResources().getString(Strings.number_cannot_be_same_as_the_logged_in_number));
                return false;
            }

            return true;
        }
        return false;
    }
    
    validate(): boolean
    {
        if(this.contactNumber.validate())
        {
            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.contactNumber.getData());
            
            let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
            let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

           
            if(!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength))
            {
                this.contactNumber.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                return false;
            }
            return true;   
        } 
        return false;    
    }

    getMSISDNData(): SubscriberValidationDtoImpl
    {
        let request = new SubscriberValidationDtoImpl();
        request.setMsisdn(this.contactNumber.getData());

        return request;
    }

    getSpecialCallerData(): string
    {
        return this.specialCallerRef.getData();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/setflashmessage/setflashmessageview.tsx